import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import CarItem from "../common/caritem";

const RelatedCars = (props) => {
	const { stype, cars, isNewTab, isLogged, openNewWindow, togglePopup, showLoginForm } = props;
	return (
		<div className="related-car space sec">
			<div className="m-container">
				<h6>Xe tương tự </h6>
			</div>
			<div className="m-container">
				<Swiper
					className="swiper-related-car"
					modules={[Navigation, Pagination]}
					slidesPerView={1}
					spaceBetween={10}
					navigation={{
						nextEl: ".related-car-next",
						prevEl: ".related-car-prev",
					}}
					pagination={{
						el: ".pagi-related",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						992: {
							slidesPerView: 4,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 2.5,
							spaceBetween: 10,
						},
						481: {
							slidesPerView: 1.4,
						},
					}}>
					{cars &&
						cars.map((featureCar, i) => (
							<SwiperSlide key={i}>
								<CarItem
									openNewWindow={openNewWindow}
									avatar={true}
									isNewTab={isNewTab}
									car={featureCar}
									togglePopup={togglePopup}
									stype={stype}
									relatedCar={true}
									showLoginForm={showLoginForm}
									isLogged={isLogged}
									fav={true}
								/>
							</SwiperSlide>
						))}
					<div className="swiper-pagination pagi-related" />
				</Swiper>
				<div className="swiper-button-next related-car-next"></div>
				<div className="swiper-button-prev related-car-prev"></div>
			</div>
		</div>
	);
};

export default RelatedCars;
